export function deprecated(...insteadUse: string[]): (target: Function) => void {
  return (target: Function) => {
    return;
  };
}
